import { useState } from 'react';
import store from '../../store';

export const usePagination = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);

  return {
    page,
    setPage,
    limit,
    setLimit,
  };
};

export const generateFilters = (payload) => {
  store.dispatch({
    type: 'FILTERS:GENERATE_FILTERS',
    payload,
  });
};

export const generateFiltersExtraData = (payload) => {
  store.dispatch({
    type: 'FILTERS:GENERATE_FILTERS_EXTRA_DATA',
    payload,
  });
};

export const ARdetailedFiltersData = (payload) => {
  store.dispatch({
    type: 'FILTERS:ARDETAILED_FILTERS_DATA',
    payload,
  });
};

export const generateFiltersForMultiSelect = (payload) => {
  store.dispatch({
    type: 'FILTERS:GENERATE_FILTERS_FOR_MULTI_SELECT',
    payload,
  });
};

export const generateDashboardFilters = (payload) => {
  store.dispatch({
    type: 'FILTERS:GENERATE_DASHBOARD_FILTERS',
    payload,
  });
};

export const generateParentChildStatus = (payload) => {
  store.dispatch({
    type: 'FILTERS:GENERATE_PARENT_CHILD_STATUS',
    payload,
  });
};

export const generateDefaultMultiSelect = (payload) => {
  store.dispatch({
    type: 'FILTERS:GENERATE_DEFAULT_MULTI_SELECT',
    payload,
  });
};
